module.exports = __webpack_public_path__ + "static/media/IMG_7284-min.720c6f58.jpg";